import Swiper from 'swiper/bundle';


const HomeHero = () => {
    const sliders = document.querySelectorAll('.home-hero__swiper');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.home-hero__swiper-wrapper');

        if (!swiperWrapper) return;
        const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 800,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        on: {
            slideChange() {
                const activeSlide = this.slides[this.activeIndex];
                if (!activeSlide) return;

                const video = activeSlide.querySelector('video');

                if (video) {
                    // Stop all videos in other slides
                    this.slides.forEach(slide => {
                        const v = slide.querySelector('video');
                        if (v) {
                            v.pause();
                            v.currentTime = 0;
                            v.onended = null;
                        }
                    });

                    // Pause Swiper autoplay while video plays
                    this.autoplay.stop();
                    video.play().catch(() => {});

                    video.onended = () => {
                        this.slideNext();
                        this.autoplay.start();
                    };
                }
            }
        }
        });
    });
};

export default HomeHero;
